import BaseBlock from "./BaseBlock";

class Accordion extends BaseBlock {
	protected cards!: NodeListOf<HTMLElement>;

	init(): void {
		this.cards = this.block.querySelectorAll(".card");

		this.cards.forEach(card => {
			card.querySelector(".collapse")?.addEventListener("shown.bs.collapse", this.onShow.bind(this));
			card.querySelector(".collapse")?.addEventListener("hide.bs.collapse", this.onHide.bind(this));
		});
	}

	protected onShow(e: Event) {
		const card = (<HTMLElement>e.currentTarget).closest(".card");
		if (card instanceof HTMLElement) {
			card.classList.add("active");
		}
	}

	protected onHide(e: Event) {
		const card = (<HTMLElement>e.currentTarget).closest(".card");
		if (card instanceof HTMLElement) {
			card.classList.remove("active");
		}
	}

}

export default Accordion;
